---
title: "Process Innovation Imperative: Differentiate Your Business Through Capability Driven Innovation"
slug: process-innovation-imperative
type: book
status: published
featured: true
summary: Formal capability models do not kill creativity — they are incomplete without a way to facilitate revolutionary and evolutionary process breakthroughs.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2003-01-01"
lastReviewedAt: "2026-09-18"
audiences:
  - business
  - product-developer
themes:
  - product-lines
  - platform-architecture
  - innovation-systems
sourceUrl: https://www.amazon.com/Process-Innovation-Imperative-Differentiate-Capability/dp/1105627780
originalAuthor: Jay van Zyl
sourceRelationship: first-party authored book
rightsStatus: first-party
seoDescription: Process Innovation Imperative (2003, later Lulu edition) by Jay van Zyl on capability-driven innovation.
canonicalPath: /resources/process-innovation-imperative
isbn: "9781105627781"
year: 2003
---

First published 2003; later paperback/ePub on Lulu (2012 listing).

> Formal processes, such as those presented in various capability based models, do not dampen innovation, nor slow down creativity, but are incomplete in facilitating innovation to its full potential. Process Innovation is the fundamental concept needed to facilitate revolutionary and evolutionary process development breakthroughs in organizations that wish to remain sustainable and competitive.

- [Lulu](http://www.lulu.com/shop/jay-van-zyl/process-innovation-imperative-differentiate-your-business-through-capability-driven-innovation/paperback/product-20485069.html)
- [Amazon](https://www.amazon.com/Process-Innovation-Imperative-Differentiate-Capability/dp/1105627780)
